
const CONFIG = Object.assign({
  linktree:  "https://linktr.ee/mariahangeliq",
  youtubeId: "dQw4w9WgXcQ",
  presaveUrl:"https://orcd.co/alaquefui",
  storeUrl:  "#store",
  release: { title: "Next Single", date: "2026-08-14T00:00:00-04:00" }
}, window.MARIAH_CONFIG || {});

/* ---- wire the redirect / link buttons ---- */
document.querySelectorAll('[data-listen]').forEach(el=>el.href = CONFIG.linktree);
document.getElementById('presaveBtn').href = CONFIG.presaveUrl;
const shopBtnEl = document.getElementById('shopBtn'); if (shopBtnEl) shopBtnEl.href = CONFIG.storeUrl;
document.querySelectorAll('[data-shop]').forEach(el=>el.href = CONFIG.storeUrl);
document.getElementById('yr').textContent  = new Date().getFullYear();

/* ---- nav: scrolled state + mobile toggle + active link ---- */
const nav = document.getElementById('nav');
addEventListener('scroll',()=>nav.classList.toggle('scrolled',scrollY>40),{passive:true});
const navLinks = document.getElementById('navLinks'), navToggle = document.getElementById('navToggle');
navToggle?.addEventListener('click',()=>{
  const open = navLinks.classList.toggle('open');
  navToggle.setAttribute('aria-expanded',open);
});
navLinks.addEventListener('click',e=>{if(e.target.tagName==='A'){navLinks.classList.remove('open');navToggle?.setAttribute('aria-expanded',false);}});

/* ---- video modal (unlisted YouTube, privacy mode) ---- */
const modal = document.getElementById('modal'), frame = document.getElementById('modalFrame');
function openVideo(){
  frame.innerHTML =
    '<iframe src="https://www.youtube-nocookie.com/embed/'+CONFIG.youtubeId+
    '?autoplay=1&rel=0" title="Mariah Angeliq" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>';
  modal.classList.add('open');
}
function closeVideo(){modal.classList.remove('open');frame.innerHTML='';}
document.querySelectorAll('[data-video]').forEach(b=>b.addEventListener('click',openVideo));
document.getElementById('modalClose').addEventListener('click',closeVideo);
modal.addEventListener('click',e=>{if(e.target===modal)closeVideo();});
addEventListener('keydown',e=>{if(e.key==='Escape')closeVideo();});

/* ---- toast helper ---- */
const toast=document.getElementById('toast');let toastT;
function showToast(msg){toast.textContent=msg;toast.classList.add('show');clearTimeout(toastT);toastT=setTimeout(()=>toast.classList.remove('show'),2600);}

/* ---- newsletter (front-end only — connect to Shopify/Klaviyo later) ---- */
document.getElementById('newsForm').addEventListener('submit',e=>{
  e.preventDefault();
  const v=document.getElementById('newsEmail').value.trim();
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){showToast('Enter a valid email');return;}
  document.getElementById('newsEmail').value='';
  showToast("You're on the list.");
});

/* ---- countdown (fixed: no more crash once the date passes, shows "Out Now") ---- */
(function(){
  var cdTitleEl = document.getElementById('cdTitle');
  var cdDateEl  = document.getElementById('cdDate');
  var presave   = document.getElementById('presaveBtn');
  if(!cdTitleEl) return;

  var targetDate = new Date(CONFIG.release.date);
  var target = targetDate.getTime();
  var validDate = !isNaN(target);

  cdTitleEl.textContent = CONFIG.release.title;
  if(cdDateEl){
    cdDateEl.textContent = validDate
      ? targetDate.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'})
      : '';
  }

  var pad = function(n){ return String(n).padStart(2,'0'); };
  var ids = ['cd-d','cd-h','cd-m','cd-s'];
  var iv; // declared with var (not const) so it's always safely defined, even
          // if tick() fires its "time's up" branch on the very first call.

  function showOutNow(){
    ids.forEach(function(id){ var el=document.getElementById(id); if(el) el.textContent='00'; });
    cdTitleEl.textContent = 'Out Now';
    if(presave){ presave.textContent = 'Listen now'; presave.href = CONFIG.linktree; }
    clearInterval(iv);
  }

  function tick(){
    var diff = target - Date.now();
    if(!validDate || diff <= 0){ showOutNow(); return; }
    var s = Math.floor(diff/1000);
    var d = document.getElementById('cd-d'); if(d) d.textContent = pad(Math.floor(s/86400));
    var h = document.getElementById('cd-h'); if(h) h.textContent = pad(Math.floor(s%86400/3600));
    var m = document.getElementById('cd-m'); if(m) m.textContent = pad(Math.floor(s%3600/60));
    var sec = document.getElementById('cd-s'); if(sec) sec.textContent = pad(s%60);
  }

  tick();
  iv = setInterval(tick, 1000);
})();

/* ---- reveal on scroll ---- */
const io=new IntersectionObserver((es)=>es.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));


/* ---- in-file tab router: Home / Music (click-driven, sandbox-safe) ---- */
(function(){
  const views={home:document.getElementById('view-home'),music:document.getElementById('view-music'),store:document.getElementById('view-store'),story:document.getElementById('view-story')};
  const links=[...document.querySelectorAll('.nav__links a')];
  const navLinksEl=document.getElementById('navLinks'), navToggleEl=document.getElementById('navToggle');
  function setActive(want){
    links.forEach(a=>a.removeAttribute('aria-current'));
    const el=links.find(a=>a.getAttribute('href')===want);
    if(el) el.setAttribute('aria-current','page');
  }
  function show(view){
    Object.entries(views).forEach(([k,el])=>{if(el) el.classList.toggle('is-active',k===view);});
    if((view==='music'||view==='store'||view==='story')&&views[view]) views[view].querySelectorAll('.reveal').forEach(e=>e.classList.add('in'));
  }
  function navigate(id){
    if(id==='music'){show('music');setActive('#music');window.scrollTo({top:0});}
    else if(id==='store'){show('store');setActive('#store');window.scrollTo({top:0});}
    else if(id==='story'){show('story');setActive('#story');window.scrollTo({top:0});}
    else{
      show('home');setActive('#home');
      const t=(id&&id!=='home')?document.getElementById(id):null;
      if(t){requestAnimationFrame(()=>t.scrollIntoView({behavior:'smooth'}));}
      else{window.scrollTo({top:0});}
    }
  }
  /* intercept EVERY in-page hash link so nothing ever tries to navigate away */
  document.addEventListener('click',function(e){
    const a=e.target.closest?e.target.closest('a[href^="#"]'):null;
    if(!a) return;
    e.preventDefault();
    navigate(a.getAttribute('href').slice(1));
    if(navLinksEl) navLinksEl.classList.remove('open');
    if(navToggleEl) navToggleEl.setAttribute('aria-expanded','false');
  });
  addEventListener('hashchange',function(){navigate((location.hash||'#home').slice(1));});
  navigate((location.hash||'#home').slice(1));
})();
